import React from 'react';
import './Styles.css';
import { useGlobalAddressContext } from '../../../../AddressInfo';
import { formatMessage } from '../../../../../../../../../Localization/formatMessage';
import Messages from '../../../../../../../../../Localization/Messages';
import { addressReducerTypes } from '../../../../Reducer';
import CheckBox from '../../../../../../../../../Elements/ids/InputElements/CheckBox';

const AddressInheritanceCheckBox = () => {
  const { addressDispatch, addressState } = useGlobalAddressContext();

  return (
    <CheckBox
      label={formatMessage(Messages.addressInfo_checkBox)}
      onChange={() => {
        addressDispatch({ type: addressReducerTypes.changeInheritance });
      }}
      checked={addressState.isInherited}
      cssClasses="team-page_address-info_inheritance-checkbox"
    />
  );
};

export default AddressInheritanceCheckBox;
